import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

import { LoadingComponent } from "../components/common";
import SidebarComponent from "../components/home/sidebarComponent";
import ChooseEmployeesForEditSTP from "../components/setting/chooseEmployeesForEditSTP";
import { SessionUserStyles } from "./PagesStyle";

class SelectEmployeeCloseFY extends Component {
  render() {
    const { classes, isLoading, mixpanel, history } = this.props;

    return (
      <div className={classes.root}>
        <CssBaseline />
        <SidebarComponent />
        <main className={classes.content}>
          <LoadingComponent isLoading={isLoading} />
          <div className={classes.appBarSpacer} />
          <ChooseEmployeesForEditSTP mixpanel={mixpanel} history={history} />
        </main>
      </div>
    );
  }
}

SelectEmployeeCloseFY.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool
};

const mapStateToProps = state => ({
  isLoading: state.employees.isLoading || state.payroll.isLoading
});

export default connect(
  mapStateToProps,
  null
)(withStyles(SessionUserStyles)(SelectEmployeeCloseFY));
